var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "14px",
    viewBox: "0 0 18 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "rect1137") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Driver-07",
    transform: "translate(-313.000000, -250.000000)",
    fill: "#585858"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tarjeta",
    transform: "translate(312.000000, 247.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.12353533,3.7514648 C2.09559598,3.7514648 1.2509766,4.59612869 1.2509766,5.62404222 L1.2509766,14.3715797 C1.2509766,15.3994939 2.09559598,16.2502128 3.12353533,16.2502128 L16.872316,16.2502128 C17.9002548,16.2502128 18.7497576,15.3994939 18.7497576,14.3715797 L18.7497576,5.62404222 C18.7497576,4.59612869 17.9002548,3.7514648 16.872316,3.7514648 L3.12353533,3.7514648 Z M3.12329057,4.996582 L16.8720706,4.996582 C17.229132,4.996582 17.4995115,5.26698693 17.4995115,5.62404248 L17.4995115,7.4978456 L2.5007325,7.4978456 L2.5007325,5.62404248 C2.5007325,5.26698693 2.76622983,4.996582 3.12329117,4.996582 L3.12329057,4.996582 Z M2.5007325,8.7480468 L17.4995115,8.7480468 L17.4995115,14.3718345 C17.4995115,14.7288898 17.229132,14.9992948 16.8720706,14.9992948 L3.12329117,14.9992948 C2.76622983,14.9992948 2.5007325,14.7288898 2.5007325,14.3718345 L2.5007325,8.7480468 Z M13.0612217,11.8768151 C12.721758,11.9217376 12.4634662,12.4704733 12.4797312,13.112321 C12.4959951,13.7541688 12.780855,14.2538981 13.121034,14.2372904 L15.6222538,14.2372904 C15.8487894,14.2465471 16.0602584,14.0237041 16.174973,13.6546586 C16.2896889,13.2857493 16.2896889,12.8283562 16.1749753,12.4594468 C16.0602618,12.0904013 15.8487939,11.8675583 15.6222583,11.8768151 L13.1210329,11.8768151 C13.1011071,11.8750454 13.0811464,11.8750454 13.0612206,11.8768151 L13.0612217,11.8768151 Z",
    id: "rect1137"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/card.d771dd44540dce41c7232449c2aec130.svg";
export { ForwardRef as ReactComponent };